import PeopleCardRoute from '../store/schema/PeopleCardRoute';
import { getPeopleCardRouteStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * This mutator action needs to be used only in route registration handlers,
 * to avoid the duplicate logging of data point which is triggered because of
 * owa-router triggers, when we change route within people card.
 */
export default mutatorAction('reloadPeopleCardMutator', (route: PeopleCardRoute) => {
    const store = getPeopleCardRouteStore();
    store.currentRoute = route;
});
